import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/queryClient";
import { deleteSession } from "@/utils/multi-session";

export function useDeleteSessionPermanently() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (sessionId: string) => {
      const ok = await deleteSession(sessionId);
      if (!ok) {
        throw new Error("Failed to delete session");
      }
      return sessionId;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.formSessions.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.sessions.all });
    },
  });
}
